// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
/** Routes under the election resource, relative to `/sequent_backend_election`. */
export var SLATE_ROUTE = ":id/slates/:slateId";
export var CREATE_SLATE_ROUTE = ":id/create-slate";
export var slatePath = function (electionId, slateId) {
    return "/sequent_backend_election/".concat(electionId, "/slates/").concat(encodeURIComponent(slateId));
};
export var createSlatePath = function (electionId) {
    return "/sequent_backend_election/".concat(electionId, "/create-slate");
};
